import * as PromoLoader from './components/PromoLoader.css';
export default {
    PromoLoader
};
